import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {StandingsPointsDeductionDomainModel} from "./standings.points-deduction.domain-model";
import {CompetitorViewModel} from "../../../common/competitor/models/competitor-view-model";

export class StandingsPointsDeductionViewModel extends BaseViewModel {
  domainModel: StandingsPointsDeductionDomainModel;

  constructor(model) {
    super(model);

    this.competitor = model.competitor ? new CompetitorViewModel(model.competitor) : null;
    this.competitorId = model.competitorId;
    this.points = model.points;
    this.for = model.for;
    this.against = model.against;
    this.reason = model.reason;
    this.deductionDate = model.deductionDate;
    this.deductionText = model.deductionText;
  }
}